module.exports = __webpack_public_path__ + "assets/img/10c107aadaf59232ff67e4dce9f49931.svg";